// =============================================================================
// Boost.js Index
// (c) Mathigon
// =============================================================================


export * from './ajax';
export * from './audio';
export * from './animate';
export * from './browser';
export * from './confetti';
export * from './draggable';
export * from './elements';
export * from './eval';
export * from './events';
export * from './observable';
export {RouterInstance as Router} from './router';
export * from './svg';
export * from './thread';
export * from './webcomponents';

export {setAlertParent} from './components/alert';
export type {Alert} from './components/alert';
export type {IconView} from './components/icon';
export type {Modal} from './components/modal';
export type {Popup} from './components/popup';
export type {Select} from './components/select';
